export default function trackAction(event, data = {}) {
  if (global?.window?.digitalData?.trigger) {
    global.window.digitalData.trigger(event, data);
  } else {
    // TODO: need to replace with client-side-logger
    // currently there are some export issue with client-side-logger
    // console.warn('UNABLE TO TRACK', event);
  }
}
